import Image from 'next/image';

import { useTranslate } from '@/hooks/useTranslate';

import CloseIcon from '../../icon/close';
import { AvatarMode } from '..';

interface GuideProps {
  onClose?: () => void;
  onChoose?: (mode: AvatarMode) => void;
}
const Guide: React.FC<GuideProps> = (props) => {
  const { onClose, onChoose } = props;
  const { t } = useTranslate();
  const list = [
    {
      title: t('Create-from-a-video'),
      desc: t('Create-an-avatar-from-a-local-video'),
      mode: 'video',
      img: {
        width: 218,
        height: 120,
        url: '/images/avatar-guide-video.png',
      },
    },
    {
      title: t('Create-from-a-photo'),
      desc: t('Create-an-avatar-from-a-portrait'),
      mode: 'image',
      url: '/images/avatar-guide-photo.png',
      img: {
        width: 218,
        height: 140,
        url: '/images/avatar-guide-photo.png',
      },
      badge: {
        text: 'New',
        color: '#FFFFFF',
        backgroundColor: '#3a3553',
      },
    },
  ];
  return (
    <div className="select-none w-fit p-[16px] pt-[48px]  rounded-[14px] overflow-hidden relative bg-gradient-to-b from-[#1A1A4C] to-[#3D3DB2] z-[0] left-[66px]">
      <div className="absolute top-0 left-0 w-full h-full rounded-[14px]  border-[2px] border-[#FBBCBC2E] z-[1]"></div>
      <span
        className="absolute z-[2] right-[16px] top-[16px] cursor-pointer hover:opacity-80 transition-opacity"
        onClick={onClose}
      >
        <CloseIcon />
      </span>
      <div className="flex flex-col gap-[16px] relative z-[2]">
        <p className="text-[20px] font-[700] leading-[28px] text-center">
          {t('What-would-you-like-to-use-to-create-your-avatar')}
        </p>
        <div className="flex gap-[32px]">
          {list.map((item, index) => {
            return (
              <div
                className="relative group rounded-[12px] cursor-pointer"
                key={index}
                onClick={() => {
                  onChoose?.(item.mode as AvatarMode);
                }}
              >
                {/* 底层块（默认同底色；hover 变渐变） */}
                <div
                  aria-hidden
                  className="absolute inset-0 -m-[2px] rounded-[14px] opacity-0  transition-all 
                   group-hover:bg-[linear-gradient(to_left,#377AFF,#A231FF)] group-hover:opacity-100"
                />
                {item.badge ? (
                  <div
                    className="absolute z-20 right-[16px] top-[16px] w-[38px] h-[16px] leading-[16px] text-center
                    text-[10px] rounded-tr-[8px] rounded-bl-[8px] bg-[linear-gradient(180deg,#FF8000,#FF6600)] "
                  >
                    {t(item.badge.text)}
                  </div>
                ) : null}
                {/* 实际卡片内容 */}
                <div
                  className={`relative z-10 rounded-[12px] bg-[#341F92] p-[16px] ${index ? 'pt-[4px]' : ''} flex flex-col justify-end`}
                >
                  <Image
                    className="rounded-[8px]"
                    src={item.img!.url}
                    width={item.img!.width}
                    height={item.img!.height}
                    alt=""
                    unoptimized
                  />
                  <p className="text-white font-[500] leading-[22px] pt-[16px]">
                    {item.title}
                  </p>
                  <p className="text-[#F6F6F699] text-[12px] leading-[16px] pt-[4px]">
                    {item.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default Guide;
